// extracted by mini-css-extract-plugin
module.exports = {"emptyMainBox":"styles_emptyMainBox__1Zaj1","emptyLabel":"styles_emptyLabel__3ul9W","placeText":"styles_placeText__1C9SG"};